import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Taxiserviceatmumbaiinternatinalairport() {



  const cardData = {
    keyword: " Taxi Service at Mumbai International Airport ",


"headingDescription": "Royal Route Cab offers reliable and convenient taxi service at Mumbai International Airport, ensuring smooth and hassle-free airport transfers for both arrivals and departures. Whether you are traveling for business or leisure, our professional drivers provide timely pickups and drops with real-time flight tracking to avoid delays. We offer comfortable, air-conditioned vehicles including sedans, SUVs, luxury cars, and Tempo Travellers suitable for individuals, families, and groups. With 24/7 availability, transparent pricing, and no hidden charges, our airport taxi service guarantees a stress-free travel experience. Enjoy easy booking, punctual service, and comfortable rides with Royal Route Cab for all your Mumbai airport transportation needs.",

"topPlaces": [
  {
    "title": "Navi Mumbai to Lonavala",
    "description": "Lonavala is one of the most popular outstation destinations from Navi Mumbai, known for its lush green valleys, waterfalls, and scenic viewpoints. Attractions like Bhushi Dam, Tiger’s Leap, and Rajmachi Point make it a perfect weekend getaway."
  },
  {
    "title": "Navi Mumbai to Pune",
    "description": "Pune is a major cultural and IT hub near Navi Mumbai, offering attractions like Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, and vibrant food streets. It is ideal for both leisure and business travel."
  },
  {
    "title": "Navi Mumbai to Nashik",
    "description": "Nashik is a famous religious and wine tourism destination known for Trimbakeshwar Temple, Sula Vineyards, Panchavati, and Godavari Ghats. It is a popular route for pilgrims and weekend travelers."
  },
  {
    "title": "Navi Mumbai to Shirdi",
    "description": "Shirdi is one of the most visited pilgrimage destinations in India, home to the Sai Baba Temple. Travelers from Navi Mumbai often book outstation cabs for a comfortable darshan trip and return journey."
  },
  {
    "title": "Navi Mumbai to Mahabaleshwar",
    "description": "Mahabaleshwar is a beautiful hill station known for strawberry farms, scenic viewpoints, cool weather, and attractions like Venna Lake, Arthur’s Seat, and Wilson Point. It is ideal for family vacations."
  },
  {
    "title": "Navi Mumbai to Matheran",
    "description": "Matheran is a peaceful eco-friendly hill station where vehicles are restricted, offering toy train rides, forest trails, and panoramic viewpoints. It is one of the closest weekend getaways from Navi Mumbai."
  },
  {
    "title": "Navi Mumbai to Alibaug",
    "description": "Alibaug is a coastal getaway known for its clean beaches, sea forts, and relaxing atmosphere. It is a popular destination for short trips, beach outings, and family vacations."
  },
  {
    "title": "Navi Mumbai to Igatpuri",
    "description": "Igatpuri is a scenic hill station surrounded by the Sahyadri ranges, famous for waterfalls, greenery, and peaceful surroundings. It is especially popular during monsoon season trips."
  },
  {
    "title": "Navi Mumbai to Aurangabad",
    "description": "Aurangabad is known for UNESCO World Heritage Sites like Ajanta and Ellora Caves, along with historical landmarks such as Bibi Ka Maqbara and Daulatabad Fort. It is ideal for heritage tourism."
  },
  {
    "title": "Navi Mumbai to Goa",
    "description": "Goa is a top long-distance outstation destination from Navi Mumbai, famous for beaches, nightlife, water sports, and Portuguese culture. It is ideal for vacations, group trips, and holidays."
  }
],






services: [
  {
    name: "Mumbai Airport Taxi Service",
    description: "Mumbai airport taxi service offers seamless pickup and drop facilities for domestic and international travelers. This service ensures timely arrivals and departures with professional drivers and well-maintained vehicles. Ideal for business travelers, families, and tourists. It guarantees a smooth and stress-free airport transfer experience."
  },
  {
    name: "Taxi at Mumbai International Airport",
    description: "Taxi at Mumbai international airport provides convenient transportation directly from arrival terminals. This service is available for quick bookings and immediate travel. Clean vehicles and experienced drivers ensure comfort. It ensures a hassle-free journey after landing."
  },
  {
    name: "Airport Cab Service Mumbai",
    description: "Airport cab service Mumbai offers reliable travel solutions for airport pickup and drop. This service ensures punctual service and comfortable rides. Suitable for both local and outstation travelers. Professional drivers enhance safety. It guarantees a smooth transfer experience."
  },
  {
    name: "Mumbai Airport Cab Booking",
    description: "Mumbai airport cab booking allows customers to reserve their ride in advance with ease. Travelers can choose vehicle type, pickup time, and terminal location. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Airport Taxi Booking Online Mumbai",
    description: "Airport taxi booking online Mumbai provides a quick and convenient way to book airport transfers. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Pickup Drop Taxi Mumbai Airport",
    description: "Pickup drop taxi Mumbai airport offers complete transfer solutions including arrival pickup and departure drop. This service ensures timely travel and comfortable rides. Ideal for frequent travelers. It guarantees a seamless airport experience."
  },
  {
    name: "Cheap Airport Taxi Mumbai",
    description: "Cheap airport taxi Mumbai provides budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Affordable fares and transparent pricing ensure no hidden charges. It ensures economical airport travel."
  },
  {
    name: "Best Airport Cab Service Mumbai",
    description: "Best airport cab service Mumbai ensures premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available. It guarantees a reliable journey."
  },
  {
    name: "24x7 Airport Taxi Mumbai",
    description: "24x7 airport taxi Mumbai ensures round-the-clock availability for all flight schedules. This service is ideal for early morning departures and late-night arrivals. Quick booking and reliable drivers ensure timely service. It guarantees convenience anytime."
  },
  {
    name: "Private Airport Cab Mumbai",
    description: "Private airport cab Mumbai offers personalized travel with exclusive vehicle usage. Travelers can enjoy comfortable and direct transfers without sharing rides. Ideal for families and business travelers. It ensures a relaxed journey."
  },
  {
    name: "Luxury Airport Taxi Mumbai",
    description: "Luxury airport taxi Mumbai provides premium vehicles for high-end travel and VIP transfers. This service is ideal for corporate clients and special occasions. Comfortable interiors and professional chauffeurs enhance the experience. It ensures a luxurious journey."
  },
  {
    name: "Sedan Airport Cab Mumbai",
    description: "Sedan airport cab Mumbai is ideal for individuals and small families seeking affordable and comfortable airport transfers. Sedans offer smooth rides and good mileage. Suitable for city travel and airport trips. It ensures a pleasant journey."
  },
  {
    name: "SUV Airport Taxi Mumbai",
    description: "SUV airport taxi Mumbai provides spacious and comfortable travel for families and groups. SUVs offer extra space for luggage and better performance. Suitable for long-distance airport transfers. It ensures a comfortable experience."
  },
  {
    name: "Innova Airport Cab Mumbai",
    description: "Innova airport cab Mumbai is perfect for group travel and corporate airport transfers. The vehicle offers spacious seating and premium comfort. Ideal for long-distance journeys. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Reliable Airport Taxi Service Mumbai",
    description: "Reliable airport taxi service Mumbai ensures consistent and dependable transfers with well-maintained vehicles and professional drivers. This service focuses on punctuality and customer satisfaction. Suitable for all travelers. It guarantees a smooth and stress-free journey."
  }
],

tableData: [
  ["Mumbai Airport Taxi Service", "Taxi at Mumbai International Airport"],
  ["Airport Cab Service Mumbai", "Mumbai Airport Cab Booking"],
  ["Airport Taxi Booking Online Mumbai", "Pickup Drop Taxi Mumbai Airport"],
  ["Cheap Airport Taxi Mumbai", "Best Airport Cab Service Mumbai"],
  ["24x7 Airport Taxi Mumbai", "Private Airport Cab Mumbai"],
  ["Luxury Airport Taxi Mumbai", "Sedan Airport Cab Mumbai"],
  ["SUV Airport Taxi Mumbai", "Innova Airport Cab Mumbai"],
  ["Reliable Airport Taxi Service Mumbai", "Mumbai Airport Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Taxi Service at Mumbai International Airport",
    WhyChoosedescription: "Royal Route Cabs offers dependable taxi service at Mumbai International Airport for quick pickup and drop at Terminal 2 and nearby locations."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup & Drop",
    WhyChoosedescription: "We ensure timely pickup and drop services with real-time flight tracking to avoid delays and waiting time."
  },
  {
    WhyChooseheading: "Professional & Verified Drivers",
    WhyChoosedescription: "Our drivers are trained, polite, and experienced in handling airport transfers, ensuring a safe and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls and parking with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Airport Taxi Availability",
    WhyChoosedescription: "Our taxi service at Mumbai International Airport operates 24/7, ideal for late-night arrivals and early morning departures."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned for a comfortable airport transfer experience."
  },
  {
    WhyChooseheading: "Local & Outstation Travel Options",
    WhyChoosedescription: "Book taxis from Mumbai Airport for city rides, hotel transfers, or outstation travel with flexible options."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers based on your needs."
  }
]

};

const faqData = [
  { question: "Do you provide taxi service at Mumbai International Airport?", answer: "Yes, Royal Route Cabs offers reliable taxi services at Mumbai International Airport for pickup and drop." },
  { question: "Which terminal do you cover?", answer: "We provide taxi service at Terminal 2 (International) and nearby terminals." },
  { question: "Is taxi service available 24 hours?", answer: "Yes, our airport taxi service operates 24/7." },
  { question: "Do you track flight delays?", answer: "Yes, we track flight timings to ensure timely pickup even if your flight is delayed." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide outstation taxis from airport?", answer: "Yes, we provide outstation cab services directly from Mumbai Airport." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for guaranteed availability." },
  { question: "Do you provide doorstep drop?", answer: "Yes, we provide drop to home, hotel, or office from the airport." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      " I Booked taxi from Mumbai International Airport with Royal Route Cabs. On-time pickup and very smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Excellent airport taxi service. Clean car, professional driver, and hassle-free travel.",
    rating: 5
  }
];















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service at Mumbai International Airport",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-airport-taxi-service.jpg", // replace if needed
  "description": "Book taxi service at Mumbai International Airport with Royal Route Cabs for fast, safe, and reliable airport transfers. Available for pickup and drop with sedan, SUV, Innova, and luxury cars. 24x7 airport cab service at best prices.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999", // starting airport fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-airport-taxi-service"
  }
};





  return (
    <div>

<Helmet>
  <title>Taxi Service at Mumbai International Airport | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book taxi at Mumbai International Airport with Royal Route Cabs. 24x7 airport pickup and drop service with affordable fares. Safe, reliable sedan, SUV, Innova & luxury cabs available."
  />

  <meta
    name="keywords"
    content="mumbai airport taxi service, taxi at mumbai international airport, airport cab service mumbai, mumbai airport cab booking, airport taxi booking online mumbai, pickup drop taxi mumbai airport, cheap airport taxi mumbai, best airport cab service mumbai, 24x7 airport taxi mumbai, private airport cab mumbai, luxury airport taxi mumbai, sedan airport cab mumbai, suv airport taxi mumbai, innova airport cab mumbai, reliable airport taxi service mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/39.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Taxiserviceatmumbaiinternatinalairport;